import {
  REPORT_TRANSACTIONS_FRAUD_SUCCESS,
  REPORT_TRANSACTIONS_FRAUD_FAILURE,
  CLEAN_REPORT_TRANSACTIONS_FRAUD_SUCCESS,
  CLEAN_REPORT_TRANSACTIONS_FRAUD_FAILURE,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function fraudReportReducer(state = initialState, action) {
  switch (action.type) {
    case REPORT_TRANSACTIONS_FRAUD_SUCCESS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case REPORT_TRANSACTIONS_FRAUD_FAILURE:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_REPORT_TRANSACTIONS_FRAUD_SUCCESS:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_REPORT_TRANSACTIONS_FRAUD_FAILURE:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
